import CalculatorReko from './CalculatorReko'

export default class CalculatorRekoDruzstvo extends CalculatorReko {
    constructor(element) {
        super(element, {
            type: 'rekoDruzstvo',
            tarif: 'U211'
        })
    }
}